import React from "react";
import  MeetingsSettings from "./settings/MeetingSettings";
import { UserSettings } from "./settings/UserSettings";
import  { ConstraintsSettings } from "./settings/constraintSettings";
import { ConstraintGroupsSettings } from "./settings/ConstraintGroupSettings";
import { AttributesSettings } from "./settings/attributeSettings";
import { MatchEngineDryRun } from "./settings/MatchEngineDryRun";
import { MeetingMetricsPage } from "./settings/MeetingMetricsPage";
import { SystemSettings } from "./settings/SystemSettings";
import AdminFeedbackPage from "./settings/AdminFeedbackPage";


// Placeholder pages (we’ll build them later)
function Dashboard() {
    return <div><h2>Dashboard</h2></div>;
}



export default function SettingsPanel({ section }) {
    switch (section) {
        case "dashboard":
            return <Dashboard />;
        case "metrics":
            return <MeetingMetricsPage />;
        case "meetingMetrics":
            return <MeetingMetricsPage />;
        case "feedback":
            return <AdminFeedbackPage />;
        case "users":
            return <UserSettings />;
        case "meetings":
            return <MeetingsSettings />;
        case "matchengine":
            return <ConstraintsSettings />;
        case "constraints.attributes":
            return <AttributesSettings />;
        case "constraints.rules":
            return <ConstraintsSettings />;
        case "constraints.groups":
            return <ConstraintGroupsSettings />;
        case "constraints.dryrun":
            return <MatchEngineDryRun />;

        case "settings":
            return <SystemSettings />;
        default:
            return <div>Select a section from the sidebar.</div>;
    }
}
